module.exports = __webpack_public_path__ + "static/LTUnivers-BasicRegular-63be610450e38ef60b4f4c1619b158ea.ttf";